
import { Vue } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { Ghost } from '@/data/Ghosts'

interface GhostCardInterface extends Omit<Ghost, 'evidence'> {
  evidence: GhostEvidence[];
}

interface GhostEvidence {
  name: string;
  color: string;
  found: boolean;
}

export default class GhostCard extends Vue {
  @Prop(Object) readonly ghost!: Ghost;
  @Prop(Array) readonly foundEvidence!: string[];

  get ghostCard() {
    // Sort evidence and turn it into usable data for the ghost card.
    const evidence = this.ghost.evidence.sort().map((evidence): GhostEvidence => ({
      name: evidence,
      color: this.evidenceColor[evidence],
      found: this.foundEvidence.includes(evidence)
    }))

    return { ...this.ghost, evidence } as GhostCardInterface
  }

  evidenceColor: { [key: string]: string } = {
    'Spirit Box': 'is-primary',
    Fingerprints: 'is-link',
    'Ghost Writing': 'is-success',
    'Freezing Temperatures': 'is-info',
    'EMF Level 5': 'is-danger',
    'Ghost Orb': ''
  }
}
